<template>
  <PSComponentStatisticsSearch />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
